export default {
    secretaria_virtual: "Secretaría Virtual de {nombreApp}",
    secretaria: "Secretaría",
    contenido_principal: "Ir al contenido principal",
    menu_inicio: "Inicio",
    menu_solicitardiploma: "Solicitud de {textoDiploma}",
    menu_diplomas: "{textoDiplomas}",
    menu_salir: "Salir",
    si: "Sí",
    error: "ERROR",
    aceptar: "Aceptar",
    err_acceso: "Su sesión ha expirado",
    err_url: "Entrar de nuevo al sistema",
    continuar_preg: "¿Está seguro de continuar?",
    estudiante: "Estudiante",
    bienv_secretariatramites: "A través de la secretaría virtual de {nombreApp}, podrá realizar los trámites de las actividades que haya realizado.",
    bienv_tramites: "Estos trámites son personales de cada estudiante y le permitirá obtener los datos necesarios sobre sus actividades en {nombreApp}.",
    bienv_puedeshacer: "¿Qué puedes hacer?",
    bienv_consultasolicita: "Consultar {textoDiplomas} emitidos",
    soldip_solicite: "Solicite los {textoDiplomas} de las actividades que ha superado.",
    soldip_infosolicitud: "La solicitud de certificación de una actividad supondrá la generación y el envío de un email con dicho certificado firmado electrónicamente. Además, se podrá acceder al documento desde su Carpeta Ciudadana en la UM y desde la propia Secretaría Virtual de {nombreApp}.",
    soldip_pasos: "Para solicitar el {textoDiploma} de una actividad debe seguir estos pasos:",
    soldip_paso1: "Elegir la actividad de la lista que aparece abajo.",
    soldip_paso2: "Previsualizar el {textoDiploma} y comprobar que la información que aparece es la correcta. Si en la previsualización algún dato es incorrecto, deberá informar de la incidencia a {nombreApp} ({emailApp}).",
    soldip_paso3: "Si todo está correcto, pulse el botón de emisión del {textoDiploma}.",
    soldip_paso4: "Pulse en el botón para generar el {textoDiploma}.",
    soldip_condiciones: "En el listado aparecerán las actividades que cumplan todas estas condiciones:",
    soldip_condicion1: "Que no hayan sido certificadas previamente en formato digital.",
    soldip_condicion2: "Que hayan sido correctamente registradas y, en su caso, abonadas. ",
    soldip_condicion3: "Que hayan sido superadas.",
    soldip_condicion4: "Si en la previsualización algo no es correcto, deberá contactar con {nombreApp} para trasladarles que es incorrecto.",
    soldip_solicita: "Solicite su {textoDiploma}",
    soldip_puedevisua: "Puede visualizar su {textoDiploma} en",
    soldip_comprobar: "El {textoDiploma} no es correcto, no lo solicite hasta que el mismo se visualice correctamente",
    soldip_borrador: "A continuación se muestra un borrador del {textoDiploma} que se generará automáticamente. Compruebe que todos los datos sean correctos. En caso de no serlos, deberá contactar con {nombreApp} para la corrección de los mismos:",
    soldip_previsualiza: "Generando previsualización...",
    soldip_dipcorrecto: "¿El {textoDiploma} generado es correcto?",
    soldip_empty: "No dispone de actividades para las que pueda solicitar el {textoDiploma}.",
    soldip_dipok: "{textoDiploma} generado correctamente",
    soldip_dipgenerado: "{textoDiploma} generado",
    soldip_diperror: "Error al generar el {textoDiploma}",
    soldip_previsualizacion: "Previsualización del {textoDiploma}",
    soldip_actividad: "Actividad",
    soldip_previsualizar: "Previsualizar",
    soldip_generar: "Generar",
    soldip_generando: "Generando {textoDiploma}...",
    soldip_generarconfirma: "Se va a generar el {textoDiploma} de la actividad indicada, esta acción no tiene vuelta atrás, ¿está seguro/a de continuar?",
    soldip_previewerror: "Error al previsualizar, inténtelo mas tarde",
    soldip_generarerror: "Error al generar, inténtelo mas tarde",
    soldip_datosestudanteerror: "Error al introducir los datos, inténtelo mas tarde",
    diplos_titu_certi: "{textoDiplomasCap}",
    diplos_info: "En esta sección puede consultar todos sus certificados digitales de las actividades cursadas en {nombreApp} y descargar una copia auténtica de cada una de ellas.",
    diplos_info2: "Las actividades muy antiguas se certificarán exclusivamente en papel impreso por parte de {nombreApp} a petición del interesado/a.",
    diplos_generados: "{textoDiplomas} generados",
    diplos_empty: "No existen {textoDiplomas} generados.",
    diplos_actividad: "Actividad",
    diplos_fechasol: "F. Solicitud",
    diplos_dipgen: "{textoDiploma} descargado",
    diplos_titucorreo: "Enviar correo",
    diplos_infocorreo: "Se va a enviar un correo al estudiante con el {textoDiploma} adjunto.",
    diplos_pregcorreo: "¿Enviar el correo?",
    diplos_correoenv: "Correo enviado",
    diplos_anula: "Anular {textoDiploma}",
    diplos_dipanulado: "{textoDiploma} anulado",
    diplos_dipanuladook: "El {textoDiploma} se ha anulado en todos los sistemas",
    diplos_anulaerror: "No se ha podido anular el {textoDiploma}",
    diplos_infoanula: "Se va a anular el {textoDiploma} del estudiante para esta actividad.",
    diplos_infodip: "El {textoDiploma} se generó por el antiguo sistema, para obtener el mismo debe contactar con {nombreApp}",
    diplos_dipdescarga:"El diploma/certificado se ha descargado, revise la carpeta de descargas.",
    diplos_dipdescargaerror:"No se ha podido descargar, inténtelo mas tarde",
    diplos_correook: "El correo se ha enviado correctamente, revise su bandeja de entrada",
    diplos_correoerror: "No se ha podido enviar el correo, inténtelo mas tarde",    
    diplos_descarga: "Descargar {textoDiploma}",    
    diplos_correo: "Enviar correo al estudiante con el {textoDiploma}",    
    diplos_anular: "Anular el {textoDiploma}",    
    accesibilidad: "Accesibilidad",
    contactar: "Contactar",
    nombre_EEPP: "Estudios Propios",
    nombre_certic: "CERTIC",
    nombre_unimar: "UNIMAR",
    nombre_default: "Estudiantes",
    acceso: "Acceder a la aplicación",
    castellano: "Castellano",
    english: "English",
    diploma_certic: "certificado y/o diploma",
    diploma_unimar: "diploma",
    diploma_default: "certificado y/o diploma",
    diplomas_certic: "certificados y/o diplomas",
    diplomas_unimar: "diplomas",
    diplomas_default: "certificados y/o diplomas",
    diplomas_certic_cap: "Certificados y/o diplomas",
    diplomas_default_cap: "Certificados y/o diplomas",
    warn: "Atención",
    envio_correo_estudiante_info: "Por favor, indique al estudiante que si no ha recibido un correo de confirmación en 24 horas revise primero la carpeta de correo spam de su cuenta de correo.",
    error_datos_estudiante: "Corrección de los datos del estudiante para la generación del {textoDiploma}",
    error_datos_estudiante_detalle: "Por favor, detalle los datos incorrectos (máximo 4000 caracteres):",
    error_datos_estudiante_head: "El {textoDiploma} no se ha generado por no disponer los datos correctos. No lo podrá solicitar hasta que no se haya resuelto el problema.",
    error_datos_estudiante_cambioOK: "Se ha solicitado el cambio de datos. Se le enviará un correo al gestor de la actividad y a {emailEstudiante} con el cambio solicitado. {nombreApp} se encargará de su gestión",
    error_datos_estudiante_cambioKO: "No ha solicitado ningún cambio, por favor, vuelva a previsualizar el {textoDiploma} y compruebe que son correctos los datos. Si no lo son, detalle los datos que son incorrectos",
    error_datos_estudiante_cambio_generado: "Cambio solicitado",
    error_datos_estudiante_cambio_generadoOK: "La solicitud de cambio se ha generado correctamente",
    error_datos_estudiante_cambio_error: "Se ha producido un error en la solicitud de cambio",
    error_datos_estudiante_bloqueo: "No puede solicitar el {textoDiploma}, está pendiente de solucionar los cambios solicitados por parte de {nombreApp}",
    error_datos_estudiante_fichero: "Si lo desea, añada un fichero justificando el cambio",
    diploma_papel: "Diploma generado ya en papel",
    motivo_anulacion: "Por favor, indique el motivo de anulación (máximo 100 caracteres):",
    motivo_anulacion_warn: "Por favor, indique el motivo de anulación para poder continuar",
    error_datos_seleccionar_fichero: "Seleccione un fichero",
    error_datos_estudiante_antes_guardar: "Corrección de los datos del estudiante",
    error_datos_estudiante_sin_adjuntos: "No ha adjuntando ningún fichero justificando el cambio. Se enviará un email al gestor de {nombreApp} para que revise los errores expuestos, ¿está seguro de continuar?",
    error_datos_estudiante_confirma_guardar: "Se enviará un email al gestor de {nombreApp} para que revise los errores expuestos, ¿está seguro de continuar?",
    error_datos_estudiante_cancelar: "Cancelar fichero",
    error_datos_estudiante_continuar: "¿está seguro de continuar?",
  };
    